export class GridColumn {
  public title?: string;
  public field?: string;
  public width?: number;
  public type?: GridColumnTypeEnum;
}

export enum GridColumnTypeEnum {
  default = 1,
  date = 2,
  icon = 3,
  custom = 4,
  ranking = 5
}
